(function () {
  'use strict';

  function initReviewTrack(track) {
    var slides = Array.prototype.slice.call(track.querySelectorAll('.ils-prw__slide'));
    if (slides.length <= 1) return;
    var cur = 0;
    function show(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, idx) {
        s.classList.toggle('is-on', idx === cur);
        var dots = s.querySelectorAll('.ils-prw__dot');
        dots.forEach(function (d, dIdx) { d.classList.toggle('is-on', dIdx === cur); });
      });
    }
    setInterval(function () { show(cur + 1); }, 3000);
  }

  function initFallbackTrack(track, wrapper) {
    var slides = Array.prototype.slice.call(track.querySelectorAll('.ils-prw__fb-slide'));
    var fallback = wrapper.closest('.ils-prw__fallback');
    var dots = fallback ? Array.prototype.slice.call(fallback.querySelectorAll('.ils-prw__fb-dot')) : [];
    var prevBtn = fallback ? fallback.querySelector('.ils-prw__nav.prev') : null;
    var nextBtn = fallback ? fallback.querySelector('.ils-prw__nav.next') : null;
    var cur = 0;
    var timer = null;
    var resumeTimer = null;
    var AUTOPLAY_MS = 2000;
    var PAUSE_MS = 4000;

    function show(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle('is-on', idx === cur); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-on', idx === cur); });
    }
    function next() { show(cur + 1); }
    function start() { stop(); timer = setInterval(next, AUTOPLAY_MS); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function pauseThenResume() {
      stop();
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(start, PAUSE_MS);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { show(cur - 1); pauseThenResume(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(cur + 1); pauseThenResume(); });

    var startX = null;
    wrapper.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    wrapper.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 30) {
        if (dx < 0) show(cur + 1); else show(cur - 1);
        pauseThenResume();
      }
      startX = null;
    }, { passive: true });

    start();
  }

  function scan() {
    document.querySelectorAll('[id^="ilsPrwTrack-"]').forEach(function (track) {
      if (track.dataset.ilsPrwInit === '1') return;
      track.dataset.ilsPrwInit = '1';
      initReviewTrack(track);
    });
    document.querySelectorAll('[id^="ilsPrwFbTrack-"]').forEach(function (track) {
      if (track.dataset.ilsPrwInit === '1') return;
      track.dataset.ilsPrwInit = '1';
      var wrapper = track.closest('.ils-prw__fb-trackwrap');
      if (wrapper) initFallbackTrack(track, wrapper);
    });
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);

  var mo = new MutationObserver(scan);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
